module.exports = __webpack_public_path__ + "static/media/r-md14.23339ac3.png";